
import _ from 'lodash';



export const didPropChange = (props, prev, keyPaths) => {
  keyPaths = _.castArray(keyPaths);

  for(const keyPath of keyPaths) {
    let cr = _.get(props, keyPath);
    let pr = _.get(prev, keyPath);
    
    if(cr !== pr)
      return true;
  };
  return false;
  
}

export function isPropSet(props, prev, paths) {
  paths = _.castArray(paths);
  let prevNull = _.some(paths, p => (_.isNil(_.get(prev, p)) || _.isEmpty(_.get(prev, p))) );
  let nowSet = _.every(paths, p => !_.isNil(_.get(props, p)) && !_.isEmpty(_.get(props, p)));
  return Boolean(prevNull && nowSet);
}

export function getChangedProps(next, prev, keys) {
  return _.reduce(keys, (s, key) => didPropChange(next, prev, key) ? _.set(s, key, next[key]) : s, {});
}

export function hasPropBeenDefined(prev, next, path) {
  return Boolean(_.isNil(_.get(prev, path)) && !_.isNil(_.get(next, path)));
}

export function isTrueLike(val) {
  return Boolean(val === "true" || (_.isBoolean(val) && val));
}
